import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  submit() {
    const form = this.element.tagName === "FORM" ? this.element : this.element.closest("form");
    if (!form) return;
    
    const formData = new FormData(form);
    const params = new URLSearchParams(formData);
    const url = `${form.action}?${params.toString()}`;

    fetch(url, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
    .then(response => response.text())
    .then(html => {
      if (window.Turbo) {
        window.Turbo.renderStreamMessage(html);
      }
    });
  }
}
